module.exports = __webpack_public_path__ + "static/media/comingSoon.8ab4bd19.png";